import React from 'react';
import Header from '../Header/header';
import Footer from '../Footer/footer';
import MessageTemplate from './messageTemplate';

const GeneralMessage = () => {
  return (
    <>
      <Header />
      <MessageTemplate>
        <p class='text-sm font-medium text-green-800'>
          We'll be in touch with information you requested. Feel free to call us
          anytime. Have a great day!
        </p>
      </MessageTemplate>
      <Footer />
    </>
  );
};

export default GeneralMessage;
